<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Learning Goal Grade</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Learning Goal Grade</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="LearningGoalGrade">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'LearningGoalGradeList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label">Max Point (>=) </label>
                    <input type="number" id="max_point" name="max_point"
                           v-validate="'required'" min="1"
                           v-model="value.max_point" class="form-control"
                           placeholder="Max Point">
                    <div
                      class="help text-danger"
                      v-show="errors.has('max_point')"
                    >
                      {{ errors.first("max_point") }}
                    </div>
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Grade label</label>
                    <el-select
                      v-model="value.grade_label"
                      name="grade_label"
                      placeholder="select grade level"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in [
                                { value: 'basic', label: 'Basic' },
                                {
                                  value: 'intermediate ',
                                  label: 'Intermediate',
                                },
                                { value: 'advanced', label: 'Advanced' },
                              ]"
                        :key="item.value"
                        v-bind:class="{
                                'has-error': errors.has('grade_label'),
                              }"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <!--<div class="form-group ">
                    <label class="control-label">Is Active</label>
                    <el-select v-model="value.is_active" v-validate="'required'" name="is_active"
                               style="width: 100%" placeholder="select active status">
                      <el-option
                        v-for="item in [{value: 'Yes', label: 'Yes'}, {value: 'No', label: 'No'}]"
                        :key="item.value" v-bind:class="{'has-error' : errors.has('is_active')}"
                        :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <div class="help text-danger" v-show="errors.has('is_active')">
                      {{ errors.first("is_active") }}
                    </div>
                  </div>-->
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import axios from "axios";

export default {
  name: "LearningGoalGradeForm",
  metaInfo: {
    title: "Learning Goal Grade | Dotlines"
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    value: {},
  }),
  methods: {
    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/learning_goal_grades";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/learning_goal_grades/" + _this.$route.params.id
            method = "PUT";
          }
          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "LearningGoalGradeList"});
          }).catch((errors) => {
            _this.$toaster.error(errors.response.data.message);
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },

    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/learning_goal_grades/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });


      }

      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  }
}
</script>

